// extracted by mini-css-extract-plugin
export default {"container":"Selection-module__container--GeDCA","checkbox":"Selection-module__checkbox--KyrMU"};